var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hackReset
    ? _c("baidu-map", {
        staticStyle: { height: "600px" },
        attrs: {
          center: _vm.center,
          zoom: _vm.zoom,
          "scroll-wheel-zoom": true,
          model: this.currentValue
        },
        on: { ready: _vm.handler, click: _vm.getClickInfo }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }